export enum AppRoute {
  Root = '/',
  Index = '/receivingpo',
  ReceivingPO = '/receivingpo/purchaseorders',
  ManualPO = '/mpo/pos',
}
